<template>
<div>
  <div class="my-account">
    <!-- <div class="wrapper">
      <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 0.05rem 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem">当前管理员可操作以下功能：</div>
            <div class="nav acea-row row-middle">
              <div class="item" @click="userInfoList">
                <div class="pictrue"><img src="@assets/images/sendadmin.png" /></div>
                <div>授权管理</div>
              </div>
            </div>
      </div> 
    </div> -->
    <div class="wrapper"  v-for="(item, index) in deviceList" :key="index">
        <div style="border-style:solid; border-width:1px; border-color:#a35608;padding:0.36rem 0 0 0;width:95%;margin:0 auto;border-radius:0.2rem">
            <!-- <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;"
            @click="showClassPicker = true">所属寺院：
                {{item.remark}}
            </div> -->
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">当前设备：
                <input
                    type="text"
                    placeholder="请填写设备名称"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.remark"
                />
            </div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">设备编号：
                <input
                    type="text"
                    placeholder="请填写设备编号"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.deviceName"
                    disabled 
                />
            </div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">设备端口：
                <input
                    type="text"
                    placeholder="请填写设备端口数量"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.equipmentnum"
                />
            </div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">点灯时间：
                <input
                    type="text"
                    placeholder="请填写点灯时间（分钟）"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.lamptime"
                />
            </div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">流量卡号：
                <input
                    type="text"
                    placeholder="请填写流量卡编号"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.cardNum"
                />
            </div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">设备行数：
                <input
                    type="text"
                    placeholder="请填写设备行数"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.deviceRow"
                />
            </div>
            <div style="font-size:0.35rem;color:#a35608;margin-left:0.3rem;height:0.8rem;">设备列数：
                <input
                    type="text"
                    placeholder="请填写设备列数"
                    style="padding-left:0.15rem;color:#a35608;height:0.75rem;border-radius:0.1rem;border-color:#a35608;border-style:solid; border-width:1px;"
                    v-model="item.deviceColumn"
                />
            </div>
            <div class="nav acea-row row-middle" style="text-align:center;margin:0,auto;">
                <div style="width:100%;text-align:center;margin:0,auto;margin-top:0.1rem">
                  <button type="button" @click="operationLamp(0,item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2rem">
                    设备初始化
                  </button>
                  &nbsp;
                  <button type="button" @click="saveLampDevice(item)" style="border-style:solid; border-width:1px; border-color:#a35608;border-radius:0.16rem;height:0.75rem;width:2rem">
                    数据保存
                  </button>
                </div>
            </div>   
      </div>
    </div>    
  </div>

<!-- <van-picker
show-toolbar
:columns="columns"
value-key="text"
/> -->
 <van-popup v-model="showClassPicker" position="bottom">
      <van-picker
      title="请选择要查看的寺庙"
      show-toolbar
      :columns="columns"
      @confirm="onClassConfirm"
      @cancel="showClassPicker = false"
      />
 </van-popup>



</div>
</template>
<script>
import Recommend from "@components/Recommend";
// import { getBalance } from "../../api/user";
import { queryDevice,device,saveDevice } from "../../api/lamp";
import lazhu from '@assets/images/lazhu1.png'
import lazhusingle from '@assets/images/lazhusingle.png'

// import initData from '@/mixins/crud'
import VueTimepicker from 'vue2-timepicker'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'

import Datepicker from 'vuejs-datepicker';
import {zh} from 'vuejs-datepicker/dist/locale'


import { Picker } from 'vant'

import { getCategoryAll } from "@api/store";
import { mapGetters } from "vuex";
import {getUserInfoList} from "@api/user";

export default {
  name: "UserAccount",
  components: {
    Recommend,
    VueTimepicker,
    Datepicker,
    vanPicker: Picker,
  },
  props: {},
  data: function() {
//  const customFieldName = {
//       text: 'cateName',
//       values: 'id',
//     };
    return {
      adminid:0,
      cateName: "",
      cateId:0,
      columns:[],
      cardDate:"",

      showClassPicker:false,
      startTime:"",
      endTime:"",
      switchStatusFlag:true,
      switchType:true,
      isShowCalendar:false,//日历组件
      isShowCalendar1:false,//日历组件
      zh:zh,
      timingWin:0,
      currSite:"",
      deviceName:"",
      // lampNumLampSite:"",
      lazhu:lazhu,
      lazhusingle:lazhusingle,
      deviceList:[],
      now_money: 0,
      orderStatusSum: 0,
      recharge: 0,
      activity: {
        is_bargin: false,
        is_pink: false,
        is_seckill: false
      },
      lampSiteInfoList:[],
      deviceMap:new Map(),
    };
  },
  computed: mapGetters(["userInfo","isLogin"]),
  mounted: function() {
    this.cateId=this.$route.query.cateId;
    this.queryDevice();
    this.getUserInfo();
    this.getCategoryAll();
  },
  methods: {
    checkIsLogin(){
      const isLogin = this.isLogin;
      if (!isLogin) return toLogin();
    },
    getUserInfo(){
          this.$store.dispatch("USERINFO").then((res) => {
                this.adminid=res.adminid
          });
    },
    getCategoryAll(){
        let that = this;
        getCategoryAll().then(
          res => {
            if(res.data!=null){
                if(res.data.length==1){
                this.cardDate = res.data[0].cardDate
                }else{
                    res.data.forEach((item,index) => { // res.data中有值
                        this.columns.push({
                          text: item.cateName,
                          value:item.id,
                          cardDate:item.cardDate
                        })
                    })
                }
            }
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    },
    onClassConfirm(v) {
      this.cateName=v.text;
      this.cateId=v.value;
      this.showClassPicker = false;
    },
 
    operationLamp(cmd,item){
        this.$dialog.confirm({
          mes: "您确定要初始化设备吗？",
          opts: () => {
            this.device(cmd,item);
          }
        });
    },
    device(cmd,item){
        let that = this;
        let data = {
            cmd: cmd,
            equipmentnum:item.equipmentnum,
            lamptime:item.lamptime
        };
        device(data).then(
          res => {
            that.$dialog.message("操作成功");
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    },
    
    queryDevice: function() {
      this.checkIsLogin();
      let that = this;
      queryDevice(this.cateId).then(
        res => {
          this.deviceList=res.data;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    },

    saveLampDevice(item){
        let that = this;
        let data = {
            remark: item.remark,
            deviceName: item.deviceName,
            equipmentnum:item.equipmentnum,
            lamptime:item.lamptime,
            cardNum:item.cardNum,
            deviceRow:item.deviceRow,
            deviceColumn:item.deviceColumn
        };
        saveDevice(data).then(
          res => {
            that.$dialog.message("操作成功");
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    },
    userInfoList(){
        // alert(1)
        let data = {
            nickname: this.nickname
        };
       
        getUserInfoList(data).then(
          res => {
            that.$dialog.message("操作成功");
          },
          err => {
            that.$dialog.message(err.msg);
          }
        );
    }

  }
};
</script>
<style scoped>
.checked{
  background: #f78817;
 }

.center {
  width:95%; 
  height:3.5rem; 
  z-index:99; 
  top: 3rem;
  background-color:#a35608;
  position: fixed;
  left: 0;
  right: 0;
  margin:0 auto;
  border-radius:0.16rem;
}
.centerdiv {
  font-size:0.35rem;
  margin-top:0.4rem;
  margin-left:0.4rem;
  color:#f8e006;
}
.selectdiv {
  margin-left:0.2rem;
  background-color:red;
  border-radius:0.16rem;
}
.buttonStyle {
  float:left;
  text-align:center;
  line-height: 0.75rem;
  margin-right:0.5rem;
  border-style:solid;
  border-width:1px; 
  border-color:#f8e006;
  border-radius:0.16rem;
  height:0.75rem;
  width:1.2rem
}
.buttonDiv {
  font-size:0.35rem;
  margin-top:0.5rem;
  margin-left:0.4rem;
  color:#f8e006;
  float:right;
}


 </style>
